var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar_Icon",
    "data-name": "Calendar Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186",
    transform: "translate(2.433 1.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6008_-_Outline",
    "data-name": "Path 6008 - Outline",
    d: "M16.662.472H-.264A.736.736,0,0,1-1-.264.736.736,0,0,1-.264-1H16.662a.736.736,0,0,1,.736.736A.736.736,0,0,1,16.662.472Z",
    transform: "translate(1.368 8.265)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    d: "M1.472,1.472v16.19h16.19V1.472H1.472M1.472,0h16.19a1.472,1.472,0,0,1,1.472,1.472v16.19a1.472,1.472,0,0,1-1.472,1.472H1.472A1.472,1.472,0,0,1,0,17.662V1.472A1.472,1.472,0,0,1,1.472,0Z",
    transform: "translate(0 1.84)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M-.264,3.415A.736.736,0,0,1-1,2.68V-.264A.736.736,0,0,1-.264-1a.736.736,0,0,1,.736.736V2.68A.736.736,0,0,1-.264,3.415Z",
    transform: "translate(5.047 1)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M-.264,3.415A.736.736,0,0,1-1,2.68V-.264A.736.736,0,0,1-.264-1a.736.736,0,0,1,.736.736V2.68A.736.736,0,0,1-.264,3.415Z",
    transform: "translate(14.614 1)",
    fill: "#525252"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    "data-name": "Rectangle 1963",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.e41444fca1892e476b3e6981ae2de454.svg";
export { ForwardRef as ReactComponent };